module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-1-medium-ee8f5f1e542aa77ad7cbca9843973776.jpg";